<template>
  <div class="onboarding-card">
    <img src="/images/onboarding/logo-terrazon.svg" alt="Terrazon" class="ob-logo-img d-block mx-auto" />
    <p class="ob-subtitle text-center">Vamos a construir tu sueño</p>

    <div class="mb-3">
      <label for="ob-nombre" class="ob-label">Nombre Completo<span class="text-danger">*</span></label>
      <input
        id="ob-nombre"
        v-model="nombre"
        type="text"
        class="form-control ob-input"
        placeholder="Nombre, Apellidos"
        autocomplete="name"
      />
    </div>

    <div class="mb-3">
      <label for="ob-whatsapp" class="ob-label">Número de WhatsApp<span class="text-danger">*</span></label>
      <div class="d-flex gap-2">
        <select v-model="lada" class="form-select ob-input ob-lada" style="max-width: 6.5rem">
          <option value="+52">🇲🇽 +52</option>
          <option value="+1">🇺🇸 +1</option>
        </select>
        <input
          id="ob-whatsapp"
          :value="whatsapp"
          type="tel"
          inputmode="numeric"
          class="form-control ob-input"
          placeholder="Tú número a 10 dígitos"
          maxlength="10"
          autocomplete="tel-national"
          @input="onWhatsappInput"
        />
      </div>
    </div>

    <p class="ob-helper">
      Ingresa tu nombre y número celular. Te enviaremos un código por WhatsApp para verificarlo.
    </p>

    <p v-if="errorMsg" class="ob-error">{{ errorMsg }}</p>

    <button
      type="button"
      class="btn ob-btn-primary w-100 mt-2"
      :disabled="!esValido || loading"
      @click="enviar"
    >
      <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
      CONTINUAR
    </button>

    <p class="ob-legal text-center mt-3">
      Al continuar aceptas nuestro
      <a href="/avisoprivacidad" target="_blank">Aviso de Privacidad</a> y
      <a href="/avisoprivacidad" target="_blank">Términos y Condiciones</a>.
    </p>

    <p class="ob-footer">GRUPO TERRAZON SAPI DE CV</p>
  </div>
</template>

<script>
// Nombre: solo letras y espacios, mínimo 2 palabras (misma regla que el backend).
const NOMBRE_REGEX = /^[\p{L}\s]+$/u;

export default {
  name: 'PantallaDatos',
  props: {
    loading: { type: Boolean, default: false },
    errorMsg: { type: String, default: '' },
  },
  data() {
    return {
      nombre: '',
      lada: '+52',
      whatsapp: '',
    };
  },
  computed: {
    nombreValido() {
      const partes = this.nombre.trim().split(/\s+/).filter(Boolean);
      return partes.length >= 2 && NOMBRE_REGEX.test(this.nombre.trim());
    },
    whatsappValido() {
      return /^\d{10}$/.test(this.whatsapp);
    },
    esValido() {
      return this.nombreValido && this.whatsappValido;
    },
  },
  methods: {
    onWhatsappInput(e) {
      // Bloquea espacios, guiones y el prefijo +52 en el input visual: solo dígitos, 10 máx.
      this.whatsapp = e.target.value.replace(/\D/g, '').slice(0, 10);
      e.target.value = this.whatsapp;
    },
    enviar() {
      if (!this.esValido || this.loading) return;
      this.$emit('enviar', { nombre: this.nombre.trim(), lada: this.lada, whatsapp: this.whatsapp });
    },
  },
};
</script>
